var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.isBusy,"rounded":"sm"}},[_c('b-card',[(_vm.option)?_c('app-echart-line',{attrs:{"style-obj":{width: '100%', height:'100vh'},"option-data":_vm.option}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }